module.exports = __webpack_public_path__ + "img/ic_circle.87143a22.svg";